import { useAtomValue } from 'jotai';
import { FC } from 'react';
import { $SEOKepAddDate } from '~/utils/libra/seo-kep-date-exp';
import { $CurrentDiscoverKeyword } from '@discover/shared/atom';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { getTodayAndMondayDate } from 'shared/utils/format/time-formatter';
import { CollectionPage, WithContext } from 'schema-dts';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const CollectionPageJsonLD: FC = () => {
  const seoKepAddDate = useAtomValue($SEOKepAddDate);
  const keyword = useAtomValue($CurrentDiscoverKeyword);
  const { region } = useAtomValue($Locale);

  const collectionPageBase: WithContext<CollectionPage> = {
    '@context': 'https://schema.org',
    '@id': `https://www.lemon8-app.com/discover/${keyword}?region=${region}`,
    '@type': 'CollectionPage',
  };

  if (seoKepAddDate === 'v0') {
    return (
      <DynamicHead>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionPageBase) }}
          id="Page"
        />
      </DynamicHead>
    );
  }

  const { monday } = getTodayAndMondayDate();

  const collectionPageObj: WithContext<CollectionPage> = {
    ...collectionPageBase,
    dateModified: `${monday}T00:00:00+00:00`,
  };

  return (
    <DynamicHead>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(collectionPageObj) }}
        id="Page"
      />
    </DynamicHead>
  );
};
